export const columns = [
  {
    title: '编号',
    dataIndex: 'id',
  },
  {
    title: '标题',
    dataIndex: 'title',
  },
  {
    title: '副标题',
    dataIndex: 'title_sub',
  },
  {
    title: '协议附件',
    dataIndex: 'pdf_doc_info',
    scopedSlots: { customRender: 'pdf_doc_info' },
  },
  {
    title: '使用状态',
    customRender: (text, record)=>{
      return record.current===0?'非当前使用':'当前使用';
    },
  },
  {
    title: '状态',
    customRender: (text, record)=>{
      return record.status===0?'禁用':'启用';
    },
  },
  {
    title: '操作',
    dataIndex: 'operation',
    scopedSlots: { customRender: 'operation' },
  },
];

export const formData = [
  {
    name: 'title',
    lable: '标题',
    lableCol: 4,
    wrapperCol: 18,
    offset: 0,
    span: 24,
  },
  {
    name: 'title_sub',
    lable: '副标题',
    lableCol: 4,
    wrapperCol: 18,
    offset: 0,
    span: 24,
  },
  {
    name: 'pdf_doc_info',
    lable: '协议附件',
    lableCol: 4,
    wrapperCol: 18,
    offset: 0,
    span: 24,
  },
  {
    name: 'sort',
    lable: '排序',
    lableCol: 4,
    wrapperCol: 18,
    offset: 0,
    span: 24,
  },
  {
    name: 'summary',
    lable: '描述',
    lableCol: 4,
    wrapperCol: 18,
    offset: 0,
    span: 24,
  },
  {
    name: 'pdf_params',
    lable: '动态字段配置',
    lableCol: 4,
    wrapperCol: 18,
    offset: 0,
    span: 24,
  },
];
export const formData1=[
  {
    name: 'id',
    lable: '当前使用协议',
    lableCol: 4,
    wrapperCol: 18,
    offset: 0,
    span: 24,
  },
];